var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHeartAvatar = function SvgHeartAvatar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#F5F5F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2095_15526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4169 16.9124C29.3899 16.377 28.2065 16.2224 27.0764 16.4761C25.9464 16.7298 24.9426 17.3754 24.2429 18.2984L24.0017 18.5756L23.7911 18.3362C23.093 17.4031 22.0864 16.7481 20.9505 16.4877C19.8146 16.2273 18.6232 16.3784 17.5883 16.9142C16.8804 17.3083 16.278 17.8673 15.832 18.5437C15.3861 19.2202 15.1098 19.9942 15.0266 20.8002C14.9434 21.6061 15.0558 22.4203 15.3541 23.1736C15.6525 23.9269 16.1281 24.5971 16.7405 25.1276L22.9127 31.1846C23.0537 31.3291 23.222 31.4441 23.4079 31.5229C23.5938 31.6018 23.7935 31.6428 23.9954 31.6436C24.1972 31.6445 24.3973 31.6051 24.5838 31.5278C24.7703 31.4506 24.9396 31.3369 25.0817 31.1936L31.2143 25.1726C31.7743 24.699 32.2242 24.1091 32.5326 23.4438C32.841 22.7785 33.0005 22.0539 32.9999 21.3206C33.0069 20.4209 32.7703 19.5362 32.3152 18.7601C31.8602 17.9841 31.2054 17.3456 30.4169 16.9124Z",
    fill: "#FE2C55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2095_15526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(15 15)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeartAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "heart-avatar.7ecb76d4954928058b5c80d295d320dc.svg";